import { useEffect, useState } from 'react'
import { Dialog, Typography, Box, IconButton } from '@mui/material'
import InCardStack from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import { Close } from '@mui/icons-material'
import { LogoAvatar } from 'components/atoms/Icons'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import colors from 'styles/colors'
import LinkCalendarButton from 'components/molecules/oAuth/LinkCalendarButton'
import { permitted } from 'utils/permissionCheck'
import { PERMISSION_LEVEL } from 'routes/constants'
import { useTranslation } from 'react-i18next'
import { getThirdPartyOauth } from 'services/userServices'
import { getPopupConfig, setPopupConfig } from 'utils/localStorage'
import { updatePageState } from 'utils/windowHistoryHelper'
import CalendarTokenInvalidPopup from 'components/molecules/oAuth/CalendarTokenInvalidPopup'

const calendarConnectStorageKey = 'calendarConnect'
const ConnectCalendarDialog = () => {
  const [open, setOpen] = useState(false)
  const [oauthToken, setOauthToken] = useState(null)
  const { t } = useTranslation()
  const hasLicense = permitted(PERMISSION_LEVEL.LICENSED)

  const checkCalenderLinked = async () => {
    const res = await getThirdPartyOauth()
    setOauthToken(res)
    return res
  }

  useEffect(() => {
    const checkOpenPopup = async () => {
      let opened = getPopupConfig(calendarConnectStorageKey)
      const res = await checkCalenderLinked()
      if (!opened && !res.linked) {
        setOpen(true)
        setPopupConfig(calendarConnectStorageKey, true)
      } else if (window.history?.state?.usr?.openConnectCalendar) {
        if (!res.linked) {
          setOpen(true)
        }
        updatePageState({ usr: { openConnectCalendar: false } })
      }
    }
    checkOpenPopup()
  }, [])

  const signinCallback = sucess => {
    if (sucess) {
      setOpen(false)
    }
  }

  const BackgorundCircles = ({ color = colors.GoldenYellow100, sx = {} }) => (
    <Box
      sx={{
        width: 285,
        height: 285,
        borderRadius: 285,
        border: `4px solid ${color}`,
        opacity: 0.5,
        position: 'absolute',
        zIndex: 1,
        ...sx
      }}
    />
  )

  const BoxWithIcon = ({ children }) => (
    <BoxWithBackground
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 120,
        width: 120,
        boxShadow: `0px 1px 30px 0px ${colors.Grey200}`,
        borderRadius: 6
      }}>
      {children}
    </BoxWithBackground>
  )

  return (
    <>
      {hasLicense && (
        <Dialog
          open={open}
          sx={{
            '& .MuiDialog-paper': {
              maxWidth: 620,
              width: '100%'
            }
          }}>
          <BoxWithBackground
            sx={{
              backgroundColor: colors.GoldenYellow50,
              borderRadius: 0,
              padding: '32px 24px',
              height: 356,
              position: 'relative',
              overflow: 'hidden'
            }}>
            <InCardStack spacing={12} height={'100%'}>
              <RowStack
                sx={{
                  justifyContent: 'space-between',
                  borderBottom: `1px solid ${colors.Grey200}`,
                  zIndex: 2
                }}>
                <Typography>
                  {t('calendarEvents.calendarIntegration')}
                </Typography>

                <IconButton onClick={() => setOpen(false)}>
                  <Close />
                </IconButton>
              </RowStack>

              <RowStack spacing={4} justifyContent={'center'} height={'100%'}>
                <BoxWithIcon>
                  <LogoAvatar
                    variant='square'
                    sx={{ width: 64, height: 64, borderRadius: 3 }}
                  />
                </BoxWithIcon>

                <AddRoundedIcon
                  sx={{ fontSize: 42, color: colors.MidnightTeal400 }}
                />

                <BoxWithIcon>
                  <CalendarTodayIcon
                    sx={{ fontSize: 56, color: colors.MidnightTeal400 }}
                  />
                </BoxWithIcon>
              </RowStack>
            </InCardStack>

            <BackgorundCircles sx={{ top: -77, left: -96 }} />
            <BackgorundCircles sx={{ bottom: -47, left: -192 }} />
            <BackgorundCircles
              sx={{ bottom: -84, right: -118 }}
              color={colors.MutedTeal200}
            />
          </BoxWithBackground>
          <Box sx={{ padding: 24 }}>
            <InCardStack spacing={12}>
              <Typography variant='h2'>
                {t('calendarEvents.unlockFeatures')}
              </Typography>

              <Typography>
                {t('calendarEvents.connectCalendarFullyExperience')}
              </Typography>

              <LinkCalendarButton
                label={t('calendarEvents.connectCalendar')}
                signinCallback={signinCallback}
                showIcon={true}
              />
            </InCardStack>
          </Box>
        </Dialog>
      )}
      {oauthToken && (
        <CalendarTokenInvalidPopup
          oauthToken={oauthToken}
          refreshCallback={checkCalenderLinked}
        />
      )}
    </>
  )
}

export default ConnectCalendarDialog
